(() => {
  const openers = new WeakMap();

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const openButton = target.closest('[data-catalog-filter-open]');
    if (openButton) {
      const dialog = document.getElementById(openButton.getAttribute('aria-controls'));
      if (dialog instanceof HTMLDialogElement) {
        openers.set(dialog, openButton);
        dialog.showModal();
      }
      return;
    }

    const closeButton = target.closest('[data-catalog-filter-close]');
    if (closeButton) {
      closeButton.closest('dialog')?.close();
      return;
    }

    if (event.target instanceof HTMLDialogElement) {
      const rect = event.target.getBoundingClientRect();
      const inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!inside) event.target.close();
    }
  });

  document.addEventListener('close', (event) => {
    if (event.target instanceof HTMLDialogElement) {
      openers.get(event.target)?.focus();
    }
  }, true);
})();
